// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d64eee6","239":"ab04e8b1","455":"c8114302"}[chunkId] + ".chunk.js";
};